import React from 'react';
import './About.css';



const WhoWeAre = () => {
    

  return (
    <div className='backdiv'>
      <h2 className='main_heading'>WHO WE ARE</h2>
      <div className='we-are-grid'>

        {/* Left text section */}
        <div>
          <p className='main_content'>
            At Zweedo, we are a passionate team of digital marketing professionals dedicated to helping businesses thrive in the digital landscape. Our collective experience spans years of crafting successful marketing strategies, driving growth, and delivering measurable results for clients across industries.<br/>
            We believe that innovation, creativity, and data-driven strategies go hand in hand to turn digital challenges into opportunities. 
            Our mission is simple: to empower brands with the tools and tactics they need to stand out, connect meaningfully, and grow sustainably online.
          </p>
        </div>
        {/* Right image section */}
        <div>
          <div className='who_img_grid'>
           <div className='who_relative'>
            <div className='who_are_div1'>
              <img src="/who-img2.webp" alt="About Us" className='zweedo_img' loading='lazy'/>
            </div>
         </div>
            <div className='who_are_div2'>
              <img src="/who-img1.webp" alt="About Us" className='zweedo_img' loading='lazy'/>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default WhoWeAre;
